<template>
  <!-- 顶部导航 h5only -->
  <div class="goa-top-tab" :class="mode" v-if="!isMiniSize">
    <div class="goa-top-tab-item" :class="{ active: activeRoutePath === item.path}" v-for="item in navList" :key="item.path" @click="handleJump(item.path)">
      <span class="goa-top-tab-icon" :class="{ round: item.path === '/aboutme' && meUserInfo }" :style="{ backgroundImage: activeRoutePath === item.path ? item.activeImg : item.img }">
      </span>
      <Transition name="van-fade">
        <span v-if="item.path === '/im'" v-show="topMessageCount" class="goa-unread">
          {{ topMessageCount }}
        </span>
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { reactive } from 'vue'
import { hollaIm } from '@holla-world/holla-im-lib'

export default {
  name: 'goa-top-tab',
  setup() {
    const msgMap = reactive(hollaIm.msgMap)
    return {
      msgMap
    }
  },
  props: {
    mode: {
      type: String,
      default: 'center',
      validator(value){
        return ['left-center', 'center'].includes(value)
      },
    }
  },
  computed: {
    ...mapState({
      meUserInfo: (state) => state.common.meUserInfo,
      isMiniSize: (state) => state.application.isMiniSize,
      currentChatUser: (state) => state.application.currentChatUser
    }),
    activeRoutePath() {
      return this.$route.path
    },
    topMessageCount() {
      let result = this.newFriendUnReadCount
      result += Object.values(this.msgMap.data)
        .map((item) => {
          return item.lastMsg ? item.lastMsg.unreadCount || 0 : 0
        })
        .reduce((pre, next) => pre + next, 0)

      if (this.currentChatUser && this.msgMap.data[this.currentChatUser.conversation_id]) {
        result -= this.msgMap.data[this.currentChatUser.conversation_id].lastMsg.unreadCount || 0
      }

      if (result < 0) result = 0

      return result > 99 ? '99+' : result
    },
    navList() {
      const list = [
        {
          path: '/home',
          img: this.getRootCssVariableValue('--pc-tab-bar-icon-home'),
          activeImg: this.getRootCssVariableValue('--pc-tab-bar-icon-home-active')
        },
        {
          path: '/history',
          img: this.getRootCssVariableValue('--pc-tab-bar-icon-history'),
          activeImg: this.getRootCssVariableValue('--pc-tab-bar-icon-history-active')
        },
        {
          path: '/im',
          img: this.getRootCssVariableValue('--pc-tab-bar-icon-message'),
          activeImg: this.getRootCssVariableValue('--pc-tab-bar-icon-message-active')
        },
        {
          path: '/aboutme',
          img: this.getRootCssVariableValue('--pc-tab-bar-icon-user'),
          activeImg: this.getRootCssVariableValue('--pc-tab-bar-icon-user-active')
        }
      ]

      if (this.meUserInfo) {
        list.map((item) => {
          if (item.path === '/aboutme') {
            item.img = item.activeImg = `url(${this.meUserInfo.photo_read_url})`
          }
          return item
        })

        if (this.meUserInfo.tp_mode) {
          list.splice(1, 0, {
            path: '/tp',
            img: this.getRootCssVariableValue('--pc-tab-bar-icon-tp'),
            activeImg: this.getRootCssVariableValue('--pc-tab-bar-icon-tp-active')
          })
        }
      }

      return list
    }
  },
  data() {
    return {
      newFriendUnReadCount: 0
    }
  },
  methods: {
    handleJump(path) {
      console.log('jump path', path)
      if (path === this.$route.path) return;
      this.$router.push(path)
    },
    // 查询未读好友数量
    getNewTagCount() {
      this.$store
        .dispatch({
          type: 'common/getNewTagCount',
          payload: {
            chatUserId: 0
          }
        })
        .then((res) => {
          this.newFriendUnReadCount = res.data.newFriendCount
        })
    },
    getRootCssVariableValue(selector) {
      const root = document.documentElement
      // 获取全局CSS变量值
      const cssVariableValue = getComputedStyle(root).getPropertyValue(selector).trim()
      return cssVariableValue
    }
  },
  mounted() {
    this.getNewTagCount()
    console.log('goa-top-tab mounted', this.isMiniSize)
  }
}
</script>

<style lang="less" scoped>
.goa-top-tab {
  width: 380PX;
  height: 54PX;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 2PX solid hsla(0, 0%, 100%, 0.85);
  border-radius: 30PX;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10;
  background: var(--tab-bar-background);

  .goa-top-tab-item {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-align: center;
    position: relative;

    &.active {
      border-radius: 30PX;
      background: var(--tab-bar-selected-background);
    }
  }

  .goa-top-tab-icon {
    background-size: cover;
    display: block;
    width: 32PX;
    height: 32PX;

    &.round {
      border-radius: 9999PX;
      overflow: hidden;
      border: 2PX solid #fff;
    }
  }
  .goa-unread {
    position: absolute;
    top: 1PX;
    right: 16PX;
    height: 16PX;
    padding: 2Px 5Px 2Px 5Px;
    color: #000;
    font-size: 11PX;
    font-weight: 500;
    background-color: var(--main-button-background);
    border-radius: 18PX 18PX 18PX 6PX;
  }


  &.left-center {
    position: absolute;
    top: 34PX;
    left: calc((50vw - 380PX) / 2);
  }

  &.center {
    position: absolute;
    top: 34PX;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
</style>
